<template>
    <div style="display:none;" v-if="detaleDatax.machines.length">
        <div id="div1">
            <div style="line-height: 30px;font-size: 25px; margin-bottom: 5px;" align=center>
                <strong>
                    <font>出库单据</font>
                    <!-- <font>成都繁星跳动科技出库单</font> -->
                </strong>
            </div>
            <table border=0 cellSpacing=0 cellPadding=0 width="100%">
                <tbody>
                    <tr>
                        <td width="43%">
                            <p style="line-height: 30px">客户：<span> {{detaleDatax.outSupplierName}}</span></p>
                        </td>
                        <td width="33%">
                            <p style="line-height: 30px">制单人: <span>{{detaleDatax.outUserName}}</span></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p style="line-height: 30px">出库单据号: <span>{{detaleDatax.outNo}}</span></p>
                        </td>
                        <td>
                            <p style="line-height: 30px">制单时间: <span>{{detaleDatax.outTime}}</span></p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div id="div2">
            <table border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse" bordercolor="#333333">
                <thead>
                    <tr style="height:20px">
                        <td colspan="10">
                            <div align=center><b>序号</b></div>
                        </td>
                        <td colspan="20">
                            <div align=center><b>旧机名称</b></div>
                        </td>
                        <td colspan="60">
                            <div align=center><b>旧机串号</b></div>
                        </td>
                        <td colspan="10">
                            <div align=center><b>数量</b></div>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <!-- detaleDatax.machines -->
                    <tr style="height:20px" v-for="(i, index) in detaleDatax.machines" :key="index">
                        <td colspan="10" align=center>{{ index + 1 }}</td>
                        <td colspan="20" align=center>{{ i.phoneName}}</td>
                        <td colspan="60" align=center>{{ i.imei }}</td>
                        <td colspan="10" align=center>1</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr style="height:25px">
                        <td colspan="90" align=center>
                            <strong>合计</strong>
                        </td>
                        <td colspan="10" align=center tdata="SubSum" format="#">
                            #
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div id="div3">
            <div align=right>
                <strong>验货：___________________</strong>
            </div>
        </div>
        <div id="div4">
            <div align=center>
                <span tdata="pageNO" format="#" align=center>#</span>
                <span>/</span>
                <span tdata="pageCount" format="#" align=center>#</span>
            </div>
        </div>
</div>
</template>
  
<script>
/* eslint-disable */
import { getLodop } from "@/utils/LodopFuncs";
export default {
    name: 'MimeoGraph',
    props: {
        /*
        * 表格
        * */
        // 表格展示列
        detaleDatax: {
            type: Object,
            required: true
        },
        columnStyle: {
            type: Function,
            required: false
        },
        isIndex: {
            type: Boolean,
            default: true
        },
        coPies: {
            type: Number,
            default: 1
        },
        // 回显判别值的name
        judgeValue: {
            // required: true,
            type: String,
            default: 'index'
        },
       
    },
    data() {
        return {
           
        }
    },
    mounted() {
    },
    methods: {
        disableopen() {
            console.log(this.coPies);
            setTimeout(() => {
            var LODOP = getLodop();
            //初始化
            LODOP.PRINT_INIT("成都繁星跳动科技出库单");
            //设置打印纸张大小
            LODOP.SET_PRINT_PAGESIZE(1, '210mm', '297mm', "");
            //样式设置
            var strStyle = "<style> table,td,th {border-width: 1px;border-style: solid;border-collapse: collapse}</style>"
            LODOP.ADD_PRINT_TABLE(125, "5%", "90%", 360, strStyle + document.getElementById("div2").innerHTML);
            LODOP.SET_PRINT_STYLEA(0, "Vorient", 3);
            LODOP.SET_PRINT_STYLEA(0, "TextNeatRow", true);
            LODOP.ADD_PRINT_HTM(20, "5%", "90%", 150, document.getElementById("div1").innerHTML);
            LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
            LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
            LODOP.ADD_PRINT_HTM(510, "5%", "90%", 50, document.getElementById("div3").innerHTML);
            LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
            LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
            LODOP.ADD_PRINT_HTM(525, "5%", "90%", 50, document.getElementById("div4").innerHTML);
            LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
            LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
            //自动分页打印
            LODOP.NewPageA();
             //设置打印纸张份数
            LODOP.SET_PRINT_COPIES(this.coPies);
            //预览打印
            // LODOP.PREVIEW();
            // //直接打印
            LODOP.PRINT();
          }, 500)
        },
    }
}
</script>
  
<style scoped lang="scss" ref="stylesheet/scss">
.el-table-container {
    .el-pagination-c {
        text-align: right;
        margin-top: 1.5em;
        padding-bottom: 20px;
    }

    .el-row-select {
        margin-top: 6em;

        .el-col-select {
            text-align: center;
        }
    }
}
</style>
<style lang="scss">
.el-table-container {
    .el-table .has-gutter tr th {
        color: #666666;
        font-weight: bold;
        height: 40px;
        padding: 0;
    }
}
</style>
  